
import { useState } from 'react';

export default function PartnerForm() {
  const [formData, setFormData] = useState({
    inquiry_type: '',
    name: '',
    phone: '',
    email: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] =
    useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Basic validation
    if (
      !formData.inquiry_type ||
      !formData.name ||
      !formData.email ||
      !formData.message
    ) {
      setSubmitStatus('error');
      return;
    }

    if (formData.message.length > 500) {
      setSubmitStatus('error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('inquiry_type', formData.inquiry_type);
      formBody.append('name', formData.name);
      formBody.append('phone', formData.phone);
      formBody.append('email', formData.email);
      formBody.append('message', formData.message);

      const response = await fetch(
        'https://readdy.ai/api/form/d6al9hfmvg9ih2c7am70',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formBody.toString(),
        },
      );

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          inquiry_type: '',
          name: '',
          phone: '',
          email: '',
          message: '',
        });
      } else {
        // Optional: capture error details for debugging
        console.error('Form submission failed:', response.statusText);
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Unexpected error during form submission:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-12 sm:py-20 px-4 sm:px-6 bg-gray-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            応募フォーム
          </h2>
          <p className="text-xs sm:text-sm text-gray-500 tracking-widest uppercase">
            ENTRY
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-lg shadow-sm p-5 sm:p-8 space-y-4 sm:space-y-6"
          data-readdy-form
          id="partner-application-form"
        >
          <div>
            <label
              htmlFor="inquiry_type"
              className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2"
            >
              問い合わせ項目 <span className="text-red-500">※</span>
            </label>
            <select
              id="inquiry_type"
              name="inquiry_type"
              value={formData.inquiry_type}
              onChange={handleChange}
              required
              className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
            >
              <option value="">お選びください</option>
              <option value="お問い合わせ">お問い合わせ</option>
              <option value="協力業者応募">協力業者応募</option>
            </select>
          </div>

          <div>
            <label
              htmlFor="name"
              className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2"
            >
              お名前 <span className="text-red-500">※</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
            />
          </div>

          <div>
            <label
              htmlFor="phone"
              className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2"
            >
              お電話番号
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
            />
          </div>

          <div>
            <label
              htmlFor="email"
              className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2"
            >
              メールアドレス <span className="text-red-500">※</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
            />
          </div>

          <div>
            <label
              htmlFor="message"
              className="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2"
            >
              お問い合わせ内容 <span className="text-red-500">※</span>
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              maxLength={500}
              rows={5}
              className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm resize-none"
            />
            <p className="text-xs text-gray-500 mt-1">
              {formData.message.length}/500文字
            </p>
          </div>

          {submitStatus === 'success' && (
            <div className="p-3 sm:p-4 bg-green-50 border border-green-200 rounded-md text-green-800 text-xs sm:text-sm">
              送信が完了しました。ありがとうございます。
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="p-3 sm:p-4 bg-red-50 border border-red-200 rounded-md text-red-800 text-xs sm:text-sm">
              送信に失敗しました。もう一度お試しください。
            </div>
          )}

          <div className="text-center pt-2 sm:pt-4">
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full sm:w-auto px-10 sm:px-12 py-3 sm:py-4 bg-red-600 text-white text-sm font-bold rounded-md hover:bg-red-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            >
              {isSubmitting ? '送信中...' : '入力内容を確認する'}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
